import { render, staticRenderFns } from "./TheComplianceToggleButton.vue?vue&type=template&id=77ca826e&scoped=true&lang=html"
import script from "./TheComplianceToggleButton.vue?vue&type=script&lang=ts"
export * from "./TheComplianceToggleButton.vue?vue&type=script&lang=ts"
import style0 from "./TheComplianceToggleButton.vue?vue&type=style&index=0&id=77ca826e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ca826e",
  null
  
)

export default component.exports